import { EventDurationType } from './types';

export const EVENT_CONFIG = {
  LOGO: { startDate: '2026-04-03', endDate: '2026-04-13' },
  BANNER: { startDate: '2026-04-24', endDate: '2026-05-04' },
  GAME_CATEGORY: { startDate: '2026-06-05', endDate: '2026-07-19' },
  GPT_GAMES: { startDate: '2026-06-05', endDate: '2026-07-19' },
  PIGEON_GPT: { startDate: '2026-06-05', endDate: '2026-07-19' },
  LUCKY_CARD: { startDate: '2026-06-11', endDate: '2026-07-13' },
  WHEEL_SPIN_GPT: { startDate: '2026-06-05', endDate: '2026-07-19' },
  SPIN_ADDITIONAL: { startDate: '2026-06-28', endDate: '2026-07-19' }
  // EVENT_SHOP: { startDate: '2025-12-15', endDate: '2026-01-05' }
  // EVENT_MODAL: {
  //   dateList: ['2025-04-07', '2025-04-10', '2025-04-13', '2025-04-16']
  // },
  // CARD_GAME: {
  //   prodDatesWithBonuses: {
  //     '2025-04-11': { id: [505, 506, 507, 508, 509, 510], amount: [50] },
  //     '2025-04-18': { id: [535, 536, 537, 538, 539, 540], amount: [75] }
  //   },
  //   devBonuses: { id: [288, 289, 290, 291, 292, 293], amount: [50] }
  // },
  // CATCH_GAME: {
  //   prodDatesWithBonuses: {
  //     '2025-04-08': { id: [488, 494, 495, 496, 497, 498], amount: [50] },
  //     '2025-04-09': { id: [499, 500, 501, 502, 503, 504], amount: [75] },
  //   },
  //   devBonuses: { id: [282, 283, 284, 285, 286, 287], amount: [10] }
  // }
} as const satisfies Record<string, EventDurationType>;

export const EVENT_MODAL_DATES = [
  // '2025-04-07 07:00:00.000+00:00',
  // '2025-04-16 00:00:00.000+00:00'
];

export const MIN_DEPOSIT_AMOUNT: { [currency: string]: number } = {
  EUR: 30,
  USD: 30,
  NZD: 45,
  CHF: 30,
  AUD: 45,
  NOK: 300,
  CAD: 45,
  PLN: 150,
  RON: 150,
  DRL: 150,
  DKK: 225,
  SEK: 300,
  INR: 2700,
  ISK: 4500,
  CZK: 750,
  BRL: 150
};

// Catch game
export const CATCH_GAME = 'CATCH_GAME';
export const CATCH_GAME_ENDPOINT = {
  BANNER: 'catch_easter_rabbit_banner',
  HOT_TO_PLAY: 'catch_easter_rabbit_how_to_play',
  TERMS: 'catch_easter_rabbit_terms'
};
export const CATCH_GAME_KEY = 'CATCH_EASTER_RABBIT_2025_CATCH_GAME_KEY';
export const CATCH_GAME_ROUTE = 'catch_easter_rabbit';

// Card game
export const CARD_GAME = 'CARD_GAME';
export const CARD_GAME_ENDPOINT = {
  BANNER: 'easter_spins_banner',
  HOT_TO_PLAY: 'easter_spins_how_to_play',
  TERMS: 'easter_spins_terms',
  GAME_END: 'easter_spins_terms'
};
export const CARD_GAME_KEY = 'EASTER_SPINS_2025_CARD_GAME_KEY';
export const CARD_GAME_ROUTE = 'easter_spins';

// Event Shop
export const EVENT_SHOP_ROUTE = 'shop';
export const EVENT_SHOP_ABOUT = 'about_shop';
export const EVENT_SHOP_MORE_ABOUT_SHOP = 'more_about_shop';
// возможность сделать отдельные переводы для разных магазинов
export const EVENT_SHOP_NAME = 'eventShop';

// Event Modal
export const EVENT_MODALS_KEY = 'eventModalDates';

// Event Game Category
export const EVENT_GAME_CATEGORY = 'football_cup';
export const EVENT_GAME_CATEGORY_NAME = 'Football Cup';
export type EVENT_GAME_CATEGORY_TYPE = typeof EVENT_GAME_CATEGORY;
